<ng-container *transloco="let t">
  @if (department$ | async; as department) {
    <header
      class="bg-full-white items-center"
      tuiHeader
      [scrollHeaderTitle]="t('Administration du groupe {{name}}', { name: department.name })">
      <pxc-department-avatar size="l" [name]="department.name" />
      <h1 tuiTitle>
        {{ department.name }}
        <span tuiSubtitle>{{ t('Administration du groupe') }}</span>
      </h1>
    </header>
  }

  <nav class="sticky z-20 pt-2" tuiNavigationNav>
    <tui-tabs>
      @for (tab of tabs; track tab.link) {
        <button
          queryParamsHandling="merge"
          tuiTab
          type="button"
          [attr.data-testid]="tab.link"
          [routerLink]="tab.link"
          [routerLinkActive]="['active']">
          {{ tab.title }}
        </button>
      }
    </tui-tabs>
  </nav>

  <div class="grid-cols-[minmax(0,1fr)] overflow-x-clip" [tuiSlides]="slideDirection()">
    <router-outlet />
  </div>
</ng-container>
